// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Routes from './routes'
import VueMarqueeSlider from 'vue-marquee-slider'

// import '@/assets/styles/boolland.scss';

Vue.use(VueRouter)
Vue.use(VueMarqueeSlider)

const router = new VueRouter({
  mode: 'history',
  routes: Routes
})

new Vue({
  el: '#app',
  render: h => h('router-view'),
  router
})


// WEBPACK FOOTER //
// ./src/main.js